export const validateOfficialDirectoryForm = (formFields) => {
  if (!formFields) {
    return { valid: false, error: "Form fields are required." };
  }

  if (
    formFields.cosNumber &&
    formFields.cosNumber?.length > 2 &&
    !/^(09)\d{9}$/.test(formFields?.cosNumber)
  ) {
    return { valid: false, error: "Invalid cos contact number." };
  }

  return { valid: true };
};
